// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__QBNah","gradient-flow":"Logo_gradient-flow__9HESt","link":"Logo_link__wAhKr"};